import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, FileUploadModule, DialogModule, DragDropModule, MessagesModule } from 'primeng/primeng';
import { TranslateModule } from '@ngx-translate/core';

import { NotifyModule } from 'app/notify';
import { ModalUploaderComponent } from './modal-uploader/modal-uploader.component';
import { UploaderService } from './uploader.service';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    FileUploadModule,
    NotifyModule,
    DialogModule,
    DragDropModule,
    MessagesModule,
    TranslateModule
  ],
  declarations: [
    ModalUploaderComponent
  ],
  providers: [
    UploaderService
  ],
  entryComponents: [
    ModalUploaderComponent
  ]
})
export class UploaderModule { }



// WEBPACK FOOTER //
// /dist/src/app/uploader/uploader.module.ts